import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select'
import { useAuthState } from "../../Helper/Context";
export const OfficerNameDDL = (props) => {
    const { OfficerNameID, setOfficerNameID, Flag, data, IsPost, Language, StarMark, ApiFlag,ZoneNameID,WardNameID } = props

    const { t } = useTranslation()

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    useEffect(() => {
        const data = {
            M_ZoneID :ZoneNameID.ID ,
            M_WardID:WardNameID.ID,
            M_UserID: UserID,
            Flag : ApiFlag,        
            Lanaguage: Language?.Label ,
            token: token
        }
        // { Language?.Label != '' && dispatch(OfficerNameDDLAPI({ data })) }
    }, [IsPost, Language?.Label,ZoneNameID.ID,WardNameID.ID])

    // const { DDLData } = useSelector(state => state.OfficerNameDDLData)

    // useEffect(() => {
    //     handleDDL()
    // }, [DDLData])

    // const handleDDL = () => {
    //     if (DDLData && DDLData.table && DDLData.table.length > 0) {
    //         let list = DDLData.table.map((item, index) => ({
    //             value: item.m_EmployeeID,
    //             label: item.employeeName,
    //             table_M_UserID: item.table_M_UserID,
    //         }))

    //         setOfficerNameID({
    //             DDL: list,
    //             // ID: Flag == 'Update' ? data?.m_WardID : 0,
    //             // Label: Flag == 'Update' ? data?.wardName : "Select...",
    //             ID:  0,
    //             Label: "Select...",
    //             table_M_UserID: 0,
    //         })
    //     }
    //     else {
    //         setOfficerNameID({
    //             DDL: [],
    //             ID: 0,
    //             Label: "Select...",
    //         })
    //     }
    // }
    return (
        <div className="form-group">
            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.OfficerName')} </label>
            <Select
                id='OfficerNameID'
                isClearable={false}
                // isRtl={isRtl}
                isSearchable
                maxMenuHeight={130}
                value={{ value: OfficerNameID?.ID, label: OfficerNameID?.Label ,table_M_UserID: OfficerNameID.table_M_UserID }}
                onChange={(e) => {
                    e ?
                        setOfficerNameID({ ...OfficerNameID, ID: e.value, Label: e.label ,table_M_UserID: e.table_M_UserID })
                        :
                        setOfficerNameID({ ...OfficerNameID, ID: 0, Label: "Select...",table_M_UserID: ''  })

                }}
                options={OfficerNameID?.DDL}
            />
        </div>
    )
}